import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

import { MatDialog } from "@angular/material/dialog";

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { ExcelService } from 'src/app/service/utilitarios/excel.service';
import { MaeUsuarioService } from 'src/app/service/mae-usuario.service';

import { MaeUsuarioM,MaeUsuarioE } from 'src/app/model/mae-usuario-bean';
import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { ComboM } from 'src/app/model/combo-bean';
import { Response_dml_bean } from 'src/app/model/response-dml';

@Component({
  selector: 'app-datos-personales',
  templateUrl: './datos-personales.component.html',
  styleUrls: ['./datos-personales.component.scss']
})
export class DatosPersonalesComponent implements OnInit {

  constructor(
    private maeUsuarioService:MaeUsuarioService,
    private maeTablaService:MaeTablaService,
    private excelService:ExcelService,
    private utilitarioService:UtilitarioService,
    private globalVariablesService: GlobalVariablesService,
    private dialogo: MatDialog,
  ) { }

    //variables enviado desde el padre
  id:String;
  x_titulo:String;
  x_proceso:String;

  //filtro
  listOrgano= new Array<Mae_tabla_E>();
  listPerfil= new Array<Mae_tabla_E>();
  listEstado= new Array<Mae_tabla_E>();

  maeUsuarioE = new MaeUsuarioE();

  //action del padre para el retorno de datos
  action: Subject<Response_dml_bean> = new Subject();

  ngOnInit(): void {
    this.cargarDatoInicial();
  }

  cargarDatoInicial(){

    this.utilitarioService.loading = true;

    const cargarOrgano = this.maeTablaService.getList("OFICINA").toPromise()
    .then(result => {
      this.listOrgano = result;
    });

    const cargarPerfil = this.maeTablaService.getList("PERFIL").toPromise()
    .then(result => {
      this.listPerfil = result;
    });

    const cargarEstado = this.maeTablaService.getList("ESTADO_REGISTRO").toPromise()
    .then(result => {
      this.listEstado = result;
    });


    const cargarUsuario = this.maeUsuarioService.getUser(this.globalVariablesService.getC_usuario(),"1").toPromise()
    .then(result => {
      this.maeUsuarioE = result[0];
    });

    Promise.all([cargarOrgano,cargarPerfil,cargarEstado,cargarUsuario])
      .then(response => {
        this.utilitarioService.loading = false;
      })
    .catch(error => console.log(`Error in executing ${error}`)
    );

  }

}
